import React from 'react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {GameInfo, OpenGameParameters} from '../../../../services/games/game-info';
import {observer} from 'mobx-react';
import {IModalDialogHandler} from '../../../../services/dialog/dialog.service.interface';
import {ContainerBox} from './boxes/container/container.box';
import {GameIconBox} from '../../../../basic-components/game-icon/game-icon.box';
import {PlayButtonsBox} from '../../../../basic-components/play-buttons/play-buttons.box';
import {GameIconWrapperBox} from '../../../../basic-components/game-icon-wrapper/game-icon-wrapper.box';
import {CyClass} from '../../../../../common/cy-classes';
import {Button} from '../../../../basic-ui-components/button/base/button.component';

export interface MobileDemoAndPlayComponentProps {
  gameInfo: GameInfo;
  openGameParams: OpenGameParameters;
  dialogHandler: IModalDialogHandler;
}

export const GameIconAndPlayButtonsComponent = observer(
    class GameIconAndPlayButtonsComponent extends OrbitComponent<MobileDemoAndPlayComponentProps> {

        private _openRealGame = () => {
            this.props.dialogHandler.close();
            this.props.gameInfo.open({...this.props.openGameParams, isRealMode: true});
        };

        private _openDemoGame = () => {
            this.props.dialogHandler.close();
            this.props.gameInfo.open({...this.props.openGameParams, isRealMode: false});
        };

        private _renderDemoButton(gameInfo: GameInfo) {
            if (!gameInfo.allowDemoButtonInIntermediatePage) {
                return null;
            }

            return (
                <Button
                    className={CyClass('cy-play-demo-game-button')}
                    onClick={this._openDemoGame}
                    preset="secondary"
                    fullWidth
                >
                    { this.services.translation.translate('DEMO') }
                </Button>
            );
        }

        render() {
            if (!this.services.device.isMobile) {
                return null;
            }

            const gameInfo = this.props.gameInfo;

            return (
                <ContainerBox className='cy-game-icon-and-play-buttons'>
                    <GameIconWrapperBox className='cy-game-icon-wrapper'>
                        <GameIconBox className='cy-game-icon'
                                     src={gameInfo.gameImageInsideIntermediatePage}
                                     fallbackSrc={gameInfo.getGameImagePlaceHolderUrl()}/>
                    </GameIconWrapperBox>
                    <PlayButtonsBox className='cy-play-buttons-wrapper'>
                        <Button
                            className={CyClass('cy-play-real-game-button')}
                            preset="special"
                            fullWidth
                            onClick={this._openRealGame}
                        >
                            {this.services.translation.translate('PLAY')}
                        </Button>
                        <div style={{height: "2rem"}}></div>
                        {this._renderDemoButton(gameInfo)}
                    </PlayButtonsBox>
                </ContainerBox>
            );
        }
    }
);
